<samweb-tooltip-container class="sam-center sam-margin-left sam-full-heigth">
   <div toolTipContent class="sam-tooltip-text">
      {{ 'samwin.email_dialog.category' | translate }}
   </div>
   <div
      class="category-content sam-center sam-full-heigth"
      *ngIf="
         !(category$ | isEmpty | async) &&
         !(isInbox && messageInfo?.skill?.skillConfiguration?.categories | some | async)
      "
   >
      <div class="category-content sam-center sam-full-heigth label-with-borders">
         <samweb-text-with-overflow-tooltip
            class="sam-center sam-full-heigth sam-bold category-margin category-text-content"
            [position]="'bottom'"
            [value]="category$ | async"
         >
         </samweb-text-with-overflow-tooltip>
      </div>
   </div>
   <kendo-dropdownlist
      name="Categories"
      samwebAutoFocus
      *ngIf="isInbox && messageInfo?.skill?.skillConfiguration?.categories | some | async"
      [data]="messageInfo?.skill?.skillConfiguration?.categories"
      [value]="category$ | async"
      (selectionChange)="changeSelectedCategory($event)"
   >
      <ng-template kendoDropDownListValueTemplate kendoDropDownListItemTemplate let-dataItem>
         <samweb-text-with-overflow-tooltip [position]="'bottom'" class="category-content" [value]="dataItem">
         </samweb-text-with-overflow-tooltip>
      </ng-template>
   </kendo-dropdownlist>
</samweb-tooltip-container>
